export default "__VITE_ASSET__CyWvkjSQ__"